/* Preview calculations only. Shopify remains the authority for payable totals. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.CBDInstantBenefits = api;
})(typeof window === 'object' ? window : globalThis, function () {
  'use strict';
  function cents(value) { if (!Number.isSafeInteger(value) || value < 0) throw new TypeError('Non-negative integer cents required'); return value; }
  function calculate(subtotalCents, { currency = 'EUR', hasOrderDiscount = false, walletPaidCents = 0 } = {}) {
    const subtotal = cents(subtotalCents), walletPaid = cents(walletPaidCents);
    if (currency !== 'EUR') return null;
    const tier = subtotal >= 15000 ? 15000 : subtotal >= 10000 ? 10000 : 0;
    const immediate = hasOrderDiscount ? 0 : tier === 15000 ? 1000 : tier === 10000 ? 500 : 0;
    const payable = subtotal - immediate;
    const cashbackBase = Math.max(0, payable - walletPaid);
    const cashback = Number((BigInt(cashbackBase) * 5n + 50n) / 100n);
    const next = subtotal < 10000 ? 10000 : subtotal < 15000 ? 15000 : null;
    return Object.freeze({ subtotal, tier, immediate, payable, cashback, next, remaining: next === null ? 0 : next - subtotal, excludedByCode: hasOrderDiscount });
  }
  function fromCart(cart) {
    if (!cart || cart.currency !== 'EUR' || !Array.isArray(cart.items)) return null;
    // The refill offer is still inactive in this draft; don't use six full-priced
    // refills to promise a threshold that will change when the sixth becomes free.
    if (cart.items.some(item => String(item.product_id) === '10685956292935' && item.quantity >= 6)) return null;
    if (cart.items.some(item => !Number.isSafeInteger(item.final_line_price))) return null;
    const subtotal = cart.items.reduce((sum, item) => sum + (item.gift_card ? 0 : item.final_line_price), 0);
    const hasOrderDiscount = (cart.discount_codes || []).some(item => item.applicable !== false) || (cart.cart_level_discount_applications || []).length > 0;
    return calculate(subtotal, { hasOrderDiscount });
  }
  function fromLiveCart(cart) {
    if (!cart || cart.currency !== 'EUR' || !Array.isArray(cart.items) ||
        !Number.isSafeInteger(cart.total_price) || cart.total_price < 0 ||
        cart.items.some(item => !Number.isSafeInteger(item.final_line_price) || item.final_line_price < 0)) return null;
    const subtotal = cart.items.reduce((sum, item) => sum + (item.gift_card ? 0 : item.final_line_price), 0);
    const giftCards = cart.items.reduce((sum, item) => sum + (item.gift_card ? item.final_line_price : 0), 0);
    const applications = cart.cart_level_discount_applications || [];
    const tierTitle = title => /^CBD Bassin · (5 € dès 100 €|10 € dès 150 €)( · BROUILLON)?$/.test(String(title || ''));
    const ours = applications.filter(a => a.type !== 'discount_code' && tierTitle(a.title));
    if (ours.some(a => !Number.isSafeInteger(a.total_allocated_amount) || a.total_allocated_amount < 0)) return null;
    const immediate = ours.reduce((sum, a) => sum + a.total_allocated_amount, 0);
    const excludedByCode = applications.some(a => !tierTitle(a.title) && a.total_allocated_amount > 0);
    const next = subtotal < 10000 ? 10000 : subtotal < 15000 ? 15000 : null;
    // The server total already includes its selected order discount. Never subtract it twice.
    const cashbackBase = Math.max(0, cart.total_price - giftCards);
    return Object.freeze({ subtotal, tier: immediate === 1000 ? 15000 : immediate === 500 ? 10000 : 0,
      immediate, payable: cart.total_price, cashback: Number((BigInt(cashbackBase) * 5n + 50n) / 100n),
      next, remaining: next === null ? 0 : next - subtotal, excludedByCode,
      awaitingConfirmation: subtotal >= 10000 && immediate === 0 && !excludedByCode });
  }
  return Object.freeze({ calculate, fromCart, fromLiveCart });
});
